export default __webpack_public_path__ + "static/kendra-beckley-6a52c4d4ae6b6b28351dce4c93d4b216.png";